module.exports = __webpack_public_path__ + "static/media/img4.f5c0a2d6.webp";